import { Button } from '@mui/material';
import { Colors } from 'utils';
import { MinLoader } from '../loader';

export const CreateChancel = ({
    create,
    chancel,
    onCreate,
    onClose,
    classes,
    buttonWidth,
    cancelButtonWidth,
    disabled,
    loader,
    butnClassName,
    createButnMargin,
    justifyContent,
    alignItems,
    redBtn,
    image,
    type,
    cancelRight,
    noChancel,
    height,
    id,
                                  renderSecondAction,
}) => {
    return (
        <div
            className={classes}
            style={{
                display: 'flex',
                justifyContent: justifyContent ? justifyContent : 'space-between',
                alignItems: alignItems ? alignItems : 'center',
                width: '100%',
            }}
        >
            {!noChancel && (
                <button
                    type={'button'}
                    style={{
                        width: cancelButtonWidth || buttonWidth,
                        marginRight: cancelRight ? cancelRight : '16px',
                        height: height ? height : '44px',
                    }}
                    onClick={onClose}
                    className="close-btn-box"
                >
                    {chancel}
                </button>
            )}

            {renderSecondAction && renderSecondAction()}

            <Button
                id={id ? id : 'create-save-btn'}
                type={type}
                className={`${butnClassName} create`}
                style={{
                    padding: '0 18px',
                    textTransform: 'capitalize',
                    width: buttonWidth,
                    height: height ? height : '44px',
                    backgroundColor: redBtn ? '#FE7070' : disabled ? 'rgba(52,122,240,.5)' : Colors.BackgroundBlue,
                    borderRadius: '4px',
                    fontSize: '16px',
                    fontWeight: '600',
                    color: Colors.TextWhite,
                    marginLeft: createButnMargin || '0px',
                    whiteSpace: 'nowrap',
                }}
                onClick={onCreate}
                disabled={disabled || loader}
            >
                {image && !loader && <img src={image} alt="" style={{ marginRight: '8px' }} />}
                {loader ? <MinLoader margin={'0'} color={Colors.TextWhite} /> : create}
            </Button>
        </div>
    );
};
